module.exports = __webpack_public_path__ + "img/error.157ac7aa.png";